<pdq-card>
  <div class="pdq-card__header">
    <h3>Export {{ optionDisplay }}</h3>
    <pdq-button icon="close" variant="ghost" (onClick)="dialogRef.close()"></pdq-button>
  </div>
  <pdq-divider></pdq-divider>
  <div class="pdq-card__content">
    <pdq-radio-group>
      @for (exportMethod of exportMethods; track exportMethod) {
        <pdq-radio-button
          [checked]="exportMethod.value === selectedValue"
          [value]="exportMethod.value"
          [text]="exportMethod.text"></pdq-radio-button>
      }
    </pdq-radio-group>
  </div>
  <div class="pdq-card__footer">
    <pdq-button [loading]="loading" (onClick)="onClickExport()" variant="primary">Export</pdq-button>
  </div>
</pdq-card>
